export const PRICING = {
  subscription: 49,
  trialDays: 7,
  trialCredits: 1500,
  monthlyCredits: 5000,
  creditsPerDollar: 400,
  creditValue: 0.0025,
  minTopup: 3,
} as const;
